/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageTargetsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageTargetsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageTargetsSecurity = {
  option1?: GetToolUsageTargetsSecurityOption1 | undefined;
  option2?: GetToolUsageTargetsSecurityOption2 | undefined;
};

export type GetToolUsageTargetsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageTargetsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageTargetsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetsSecurityOption1$Outbound,
  GetToolUsageTargetsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolUsageTargetsSecurityOption1ToJSON(
  getToolUsageTargetsSecurityOption1: GetToolUsageTargetsSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageTargetsSecurityOption1$outboundSchema.parse(
      getToolUsageTargetsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageTargetsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetsSecurityOption2$Outbound,
  GetToolUsageTargetsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolUsageTargetsSecurityOption2ToJSON(
  getToolUsageTargetsSecurityOption2: GetToolUsageTargetsSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageTargetsSecurityOption2$outboundSchema.parse(
      getToolUsageTargetsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetsSecurity$Outbound = {
  Option1?: GetToolUsageTargetsSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageTargetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageTargetsSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetsSecurity$Outbound,
  GetToolUsageTargetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageTargetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageTargetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageTargetsSecurityToJSON(
  getToolUsageTargetsSecurity: GetToolUsageTargetsSecurity,
): string {
  return JSON.stringify(
    GetToolUsageTargetsSecurity$outboundSchema.parse(
      getToolUsageTargetsSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageTargetsRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetsRequest$Outbound,
  GetToolUsageTargetsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageTargetsRequestToJSON(
  getToolUsageTargetsRequest: GetToolUsageTargetsRequest,
): string {
  return JSON.stringify(
    GetToolUsageTargetsRequest$outboundSchema.parse(getToolUsageTargetsRequest),
  );
}
